require('ExceptionHandler')
.define('AuctionHandler',function (imports) {
  var ExceptionHandler = imports.ExceptionHandler;

  var debugMode = ((typeof AUCTION_DEBUG !== "undefined") && (typeof console == "object"));
  var auctionPage = null;
  var websocket_messages = [];
  var channel;
  var pusher;
  var leaving_page = false;
  var pusher_was_connected = false;


  $(window).on("unload", function () {
    leaving_page = true;
  })

  /*** public ***/
  function subscribe() {
    if (auctionPage === null) {
      if (console) {console.log("auctionPage not ready, cannot subscribe.");}
      return;
    }
    channel = $("#pubnub").data('channel');
    /** some pages might call this without channel. e.g. favorites page without lots on it. */
    if (channel === null || channel === "") {
      return;
    }

    if (typeof PUBNUB === 'object') {
      var history_length = $("#pubnub").data('history-length')
      var key = $("#pubnub").data('subscribe-key')

      PUBNUB = PUBNUB.init({ subscribe_key : key, noleave : true, ssl : true});

      if (debugMode) {
        console.log("subscribing to pubnub channel "+channel);
      }
      PUBNUB.subscribe({
        channel  : channel,
        error    : function(message) {
          try {
            if (debugMode) {
              console.error("pubnub error:",message);
            }
            if (!leaving_page) {
              var s = "";
              if (message) {
                s = "" + message;
                try {
                  s = "" + message.error;
                }
                catch(e2){

                }
              }
              ExceptionHandler.instance().logMessageWithThreshold(ExceptionHandler.instance().msg('pubnub error :'+s,"Pubnub listener"));
            }
          }
          catch(e) {
          }
          // alert("Connection Lost. Will auto-reconnect when Online.");
        },
        callback : function(message) {
          handle_pubnub_message(message);
        },
        connect  : function(channel_name) { // connection established
          if (debugMode) {
            console.log("pubnub connected: "+channel_name);
          }
          replay_pubnub_history(channel_name, history_length);
        },
        reconnect: function () {
          ExceptionHandler.instance().logMessageWithThreshold(ExceptionHandler.instance().msg('pubnub was reconnected',"Pubnub listener"));
        }
      });
    }

    if (typeof Pusher !== 'undefined') {
      if (debugMode) {
        console.log("subscribing to Pusher channel "+channel);
      }

      pusher = new Pusher($("#pusher").data('subscribe-key'), { cluster: 'mt1' });
      var pusher_channel = pusher.subscribe(channel);
      pusher_channel.bind('pusher:subscription_succeeded', function(data) {
        if (debugMode) {
          console.log("pusher connected");
        }
        if (pusher_was_connected) {
          ExceptionHandler.instance().logMessageWithThreshold(ExceptionHandler.instance().msg('pusher was reconnected after disconnect',"Pusher connection listener"));
        }
        pusher_was_connected = true;
      });
      pusher_channel.bind('update', function(data) {
        handle_pubnub_message(data.message);
      });
      pusher.connection.bind('unavailable', function() {
        if (!leaving_page) {
          ExceptionHandler.instance().logMessageWithThreshold(ExceptionHandler.instance().msg('pusher became unavailable',"Pusher connection listener"));
        }
      });
    } else if (debugMode) {
    console.log("Pusher was not loaded!");
    }
  }


  /*** private ***/

  //___________ message handling__________________________

  function replay_pubnub_history(channel_name, history_length) {
    if (debugMode) {
      console.log("retrieving history of "+channel_name)
    }
    PUBNUB.history({
      channel : channel_name,
      limit   : history_length

    }, function(history_data) {
      if (debugMode) {
          console.log("pubnub_history_data",history_data);
      }
      replay_pubnub_messages(history_data[0]);
    });
  }


  function websocket_message_already_executed(uuid) {
    var found = false;
    if (jQuery.inArray( uuid, websocket_messages) > -1) {
      found = true;
    }
    else {
      websocket_messages.unshift(uuid);
    }
    websocket_messages = websocket_messages.slice(0,100);
    return found;
  }

  var handle_pubnub_message = ExceptionHandler.protect(function (message) {
    if (debugMode) {
      console.log("handle_new_pubnub_message",message["action"],message);
    }
    if (message["action"] == "bid_info" && message["publish_bid_msg"]) {
      // publish_bid_msg was used by deprecated reverted experiment of Bjarke
      // TODO: clean up this whole path, also in controllers
      return;
    }
    if (websocket_message_already_executed(message["uuid"])) {
      if (debugMode) {
        console.log("Skip message:",message["source"],message["uuid"],message["action"],message["lot_id"]);
      }
      return;
    }
    else {
      if (debugMode) {
        console.log("Execute message:",message["source"],message["uuid"],message["action"],message["lot_id"]);
      }
    }
    if (message["action"] == "publication_started") {
      handle_publication_started(message);

    } else if (message["action"] == "bidding_started") {
      handle_bidding_started(message);

    } else if (message["action"] == "auction_closed") {
      handle_auction_closed(message);

    } else if (message["action"] == "new_bid") {
      handle_new_bid(message, false);

    } else if (message["action"] == "lot_closed") {
      handle_lot_closed(message);

    } else if (message["action"] == "lot_closed_not_sold") {
      handle_lot_closed_not_sold(message);

    } else if (message["action"] == "lot_deactivated") {
      handle_lot_deactivated(message);

    } else if (message["action"] == "refresh") {
      if (!(typeof AuctionFavorites == 'undefined') && !AuctionFavorites.on_favorites_page()) {
        location.reload();
      }
    }

  })

  function replay_pubnub_messages(messages) {
    if (AuctionPage.on_page("list")) {
      // find for each lot the message with the highest bid_id, so we don't have to replay them all
      messages = highest_bid_message_per_lot(messages);
    }

    $.each(messages, function(i, message) {
      if (debugMode) {
        console.log("replay history message",message);
      }
      if (message["action"] == "new_bid") {
        handle_new_bid(message, true);
      } else if (message["action"] == "lot_closed") {
        handle_lot_closed(message);
      } else if (message["action"] == "lot_closed_not_sold") {
        handle_lot_closed_not_sold(message);
      }
    });
  }

  //_______________ implementation of specific pubnub messages ________________________

  function handle_publication_started(message) {
    location.reload();
  }

  function handle_bidding_started(message) {
    location.reload();
  }

  function handle_auction_closed(message) {
    location.reload();
  }

  function handle_new_bid(message, replay) {
    // update bid on detail page
    if (AuctionPage.is_detail_page_for_lot(message["lot_id"]) && AuctionPage.bid_not_in_history(message)) {
      AuctionPage.detail_new_bid(message, replay);
    }

    // update bid in list
    if (AuctionPage.on_page("list") && !AuctionPage.list_bid_already_updated(message)) {
      AuctionPage.list_update_bid(message, replay);
      AuctionPage.list_update_clock(message);
    }
  }

  function handle_lot_closed(message) {
    // close lot in list
    if (AuctionPage.on_page("list")) {
      AuctionPage.list_close_lot(message["lot_id"],true,message["winning_bid"]);
    }
    else {
      AuctionPage.detail_close_lot(message["lot_id"], true, message["winner_token"]);
    }
  }

  function handle_lot_closed_not_sold(message) {
    if (AuctionPage.on_page("list")) {
      AuctionPage.list_close_lot(message["lot_id"],false,null);
    }
    else {
      AuctionPage.detail_close_lot(message["lot_id"],false);
    }
  }

  function handle_lot_deactivated(message) {
    if (AuctionPage.on_page("list")) {
      AuctionPage.list_deactivate_lot(message["lot_id"]);
    }
  }


  function set_auction_page(page) {
    auctionPage = page;
  }


  /*** private ******/

  /* TODO This is a good candidate for a unit test! */
  function highest_bid_message_per_lot(messages) {
    var max_bids = {};

    $.each(messages, function (i, msg) {
      if(msg.action == "new_bid") {
        if (max_bids[msg.lot_id]) {
          max_bids[msg.lot_id] = (max_bids[msg.lot_id].bid_id < msg.bid_id ? msg : max_bids[msg.lot_id]);
        } else {
          max_bids[msg.lot_id] = msg;
        }
      }
    });

    var result = [];
    $.each(max_bids, function(lot_id, msg) {
      result.push(msg);
    });

    return result;
  }


  /*** export **/
  return {
    subscribe: subscribe,
    set_auction_page : set_auction_page
  };
});
